

import Splash0 from "../../components/Home/Page1/splash0";
import Splash1 from "../../components/Home/page2/splash1";
import Splash2 from "../../components/Home/page3/splash2";
import Splash3 from "../../components/Home/Page4/splash3";
import Splash4 from "../../components/Home/Page5/splash4";
import Splash5 from "../../components/Home/Page6/splash5";
//import StudentHome from "../../layout/mainlayout/StudentHome";


function HomePage () {
    return (
        <>
        {/* <StudentHome/> */}
       <Splash0/> 
       <Splash1/>
       <Splash2/>
       <Splash3/>
       <Splash4/>
       <Splash5/>
        {/* <Login/>
        <Checkboxes/> */}
        </>
    )
};

export default HomePage;

// import SplashSlider from "../../components/Home/Slide";

// function HomePage() {
//   return <SplashSlider />;
// }

// export default HomePage;